import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { DepartmentService } from '../proxy/planning/controllers/department.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { ZoneService } from '../proxy/planning/controllers/zone.service';

FieldBuilder.setNamespace('Planning');

export const LOCALCORRIDOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LocalCorridor.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.LocalCorridor.Code')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .foreignKey('departmentId', 'Entity.Department', DepartmentService)
    .required()
    .displayFromNested('department.name')
    .sortBy('department.name')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const LOCALCORRIDOR_CONFIG = {
  entityName: 'LocalCorridor',
  localizationKey: 'Planning::Entity.LocalCorridor',
  permission: 'GeneralLocations.LocalCorridors',
  fields: LOCALCORRIDOR_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Locations + MENU_NAME_SUFFIX,
};
